import React from 'react'
import PropTypes from 'prop-types'

import style from './style.css'

export default class Attribute extends React.Component {
  
  render() {
    return (
      <div className={style.attributeView}>{this.props.title}</div>
    )
  }

}
